// extracted by mini-css-extract-plugin
export default {"button":"style_button__B1uFG","oppositeColorBtn":"style_oppositeColorBtn__J-gPl","active":"style_active__neYQE"};